import {AnalyticsEventHandler} from "../../../../../infrastructure/handlers/analytics-event-handler";
import {FOOTER_MODULE} from "../footer-module.consts";
import {AnalyticsService} from "../../../../../third-party-services/analytics/analytics-service";
import {FooterModuleItemClickEvent} from "../models/footer-module.item-click-event";
import {FooterModuleState} from "../models/footer-module.state";

export class FooterModuleItemClickEventHandler extends AnalyticsEventHandler {
  type = FOOTER_MODULE.ACTION_TYPES.itemClickEvent;
  state: FooterModuleState;

  static injectables = [...AnalyticsEventHandler.injectables];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = FooterModuleItemClickEvent;
  }

  async action(params) {
    const clickEvent = new this.eventType(params, this.getScreen(params.currentLinkModelName));

    this.analyticsService.createEvent(clickEvent);
  }
}
